import { useEffect } from "react";
import useHistory from "routing/useHistory";
import MimecastV2Routes from "./Routes";
const MimecastV2InputConfiguration = () => {
  const history = useHistory();
  useEffect(() => {
    const url = MimecastV2Routes.INTEGRATIONS.Mimecast.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);
  return null;
};
export default MimecastV2InputConfiguration;
